// extracted by mini-css-extract-plugin
export default {"chip":"UserStatusChip_chip__J0S7Y"};